<template>
    <div>
        <transition v-if="is_initialized" name="slide-fade" mode="out-in" appear>
            <router-view>
            </router-view>
        </transition>
        <div class="ui inverted dimmer transition" :class="{'active': !is_initialized}">
            <div class="ui text loader">{{ $t('ui.general.initializing') }}</div>
        </div>
    </div>
</template>

<script>
export default {
    name: "CustomerOperationsLayout",
    data() {
        return {
            is_initialized: false,
            errors: [],
        }
    },
    computed: {
    },
    watch: {
    },
    created() {
        this.init()
    },
    mounted() {
    },
    methods: {
        async init() {
            await new Promise(resolve => {
                this.is_initialized = false
                resolve()
            })
            await new Promise(resolve => {
                this.is_initialized = true
                resolve()
            })
        },
    },
    components: {
    }
}
</script>
